import React from "react";
import "../styles/ReceiptPage.css";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import "../utils/TotalFee";
import NumberToString from "../utils/NumberToString"
const ReceiptPageComponent = ({
  studentName,
  className,
  fatherName,
  currDate,
  admissionId,
}) => {
  function printReceiptHandler() {
    window.print();
  }
  // const fees = [
  //   { class: 1  },
  //   { 2: 1100 },
  //   { 3: 11500 },
  //   { 4: 12100 },
  //   { 5: 14300 },
  //   { 6: 15400 },
  //   { 7: 17600 },
  //   { 8: 19800 },
  //   { 9: 24200 },
  //   { 10: 26400 },
  // ];

  const fees = [
    {
      class : {className : 1, fees : 10450, examFee : 1000},
    },
    {
      class : {className : 2, fees : 1100,examFee :1000 },
    },
    {
      class : {className : 3, fees : 11500,examFee :1100},
    },
    {
      class : {className : 4, fees : 12100,examFee :1100},
    },
    {
      class : {className : 5, fees : 14300,examFee :1200},
    },
    {
      class : {className : 6, fees : 15400,examFee :1400},
    },
    {
      class : {className : 7, fees : 17600,examFee :1500},
    },
    {
      class : {className : 8, fees : 19800,examFee :1500},
    },
    {
      class : {className : 9, fees : 24200,examFee :1800},
    },
    {
      class : {className : 10, fees : 26400,examFee :2200},
    },

  ]

  return (
    <div className="mainLayout">
      <div className="receiptDownloadButton">
        <button
          className="btn btn-sm btn-primary px-5"
          onClick={printReceiptHandler}
        >
          Print &nbsp; <LocalPrintshopIcon />
        </button>
      </div>
      <div className="innerReceiptLayout">
        <div className="HeaderLayout">
          <div className="HeaderLeftSideContainer">
            <p>Logo</p>
          </div>

          <div className="HeaderRightSideContainer">
            <p className="schoolName">TRIVENI HIGH SCHOOL</p>
            <p className="medium">Nursery to 10th Class English Medium</p>
            <p className="recognized">Recognized by the Govt. of T.S.</p>
            <p className="address">DOMAKONDA - 503123, Dist. Kamareddy.</p>
          </div>
        </div>
        <div className="BodyLayout">
          <div className="receiptHeader">
            <p className="receiptTitle">RECEIPT</p>
          </div>
          <div className="BodyLayoutTopContainer">
            <div className="TopContainerFirstRow">
              <div>Admission Number : {admissionId}</div>
              <div>Date : {currDate}</div>
            </div>
            <div className="TopContainerMiddleRow">
              <div>Name : {studentName}</div>
              <div>Class : {className}</div>
            </div>
            <div className="TopContainerBottomRow">
              <div>S/o : {fatherName}</div>
            </div>
          </div>
          <div className="BodyLayoutMiddleContainer">
            <table className="table receiptTable">
              <tr>
                <td className="rightBorder">PARTICULARS</td>
                <td>AMOUNT (in Rs)</td>
              </tr>
              <tr>
                <td className="rightBorder">Admission Fee</td>
                <td> </td>
              </tr>
              <tr>
                <td className="rightBorder">Tuition Fee(Month)</td> 
                <td className="myClass d-flex"><div>&#8377;</div> 
                <p className="TuitionFee">{fees.map((item)=>{
                  return (<>{item.class.className === className ? (item.class.fees)/11 : ""}</>)
                })}</p></td>  
              </tr>
              <tr>
                <td className="rightBorder">Van Fee</td>
                <td> </td>
              </tr>
              <tr>
                <td className="rightBorder">Term Fee</td>
                <td className="d-flex "><div>&#8377;</div> 
                <div >{fees.map((item)=>{
                  return (<>{item.class.className === className ? (item.class.fees) : ""}</>)
                })}</div></td>
              </tr>
              <tr>
                <td className="rightBorder">Examination Fee</td>
                <td className="d-flex "><div>&#8377;</div> 
                <div >{fees.map((item)=>{
                  return (<>{item.class.className === className ? (item.class.examFee) : ""}</>)
                })}</div></td>
              </tr>
              <tr>
                <td className="rightBorder">Games & Sports Fee</td>
                <td> </td>
              </tr>
              <tr>
                <td className="rightBorder">Computers Fee</td>
                <td> </td>
              </tr>
              <tr>
                <td className="rightBorder">Other Fee</td>
                <td> </td>
              </tr>
              <tr className="grandTotal">
                <td className="rightBorder ">GRAND TOTAL</td>
                <td>
                {/* {document.readyState ? document.getElementsByClassName('TuitionFee')[0].innerHTML:''  } */}
                
                &#8377;{fees.map((item)=>{
                  return (<>{item.class.className === className ? (item.class.fees+item.class.examFee)+(item.class.fees/11) : ""}</>)
                })}
                </td>
              </tr>
            </table>
          </div>
          <div className="BodyLayoutBottomContainer">
            <div className="w-100 d-flex justify-content-start px-2">
              <p>In words : </p>
             <div className="d-flex ml-4" style={{color:'green'}}> {fees.map((item)=>{
                  return (<>
                    <NumberToString number = {item.class.className === className ? (item.class.fees+item.class.examFee)+(item.class.fees/11) : ""}/>
                  </>) 
                })} &nbsp;Rupees Only</div>
            </div>

            <div className="SignContainer">
              <p>A.O.</p>
              <p>Principal</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ReceiptPageComponent;
